<style>
</style>
<template>
  <div class="container">
    <div>
      <div class="row">
        <div class="form-group col-md-12">
          <div class="card card-wizard" id="wizardCard">
            <div class="col-md-12 form-group">
              <div class="row m-3">
                <legend class="mb-0">Historial de declaraciones</legend>
              </div>
              <div class="row mt-3 mb-0">
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
                  </v-text-field>
                  <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
                    <template v-slot:item.acciones="{ item }">
                      <div class="d-flex justify-content-center">
                        <b-button :href="'https:'+$rootUrl+'/declaraciones_fiscales/'+item.file" class="btn-s edit mr-2" variant="primary" target="_blank" style="line-height: 25px;">
                          <!-- <i class="fas fa-external-link-square-alt"></i> -->
                          <i class="far fa-file-pdf"></i>
                        </b-button>
                        <br>
                        <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="hideButtons(item.created_at) != currentYear" :class="(hideButtons(item.created_at) != currentYear)?'btn-secondary':'btn-danger'">
                          <i class="fas fa-times"></i></b-button>
                      </div>
                    </template>

                    <template v-slot:item.anio="{ item }">
                      <div>{{checkAnio(item)}}</div>
                    </template>
                    <template v-slot:item.patrimonial="{ item }">
                      <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaResumen(item)">
                        <i class="far fa-file-pdf"></i>
                      </b-button>
                    </template>

                    <template v-slot:item.acuse="{ item }">
                      <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaAcuse(item.id)">
                        <i class="far fa-file-pdf"></i>
                      </b-button>
                    </template>

                    <template v-slot:item.manifiesto="{ item }">
                      <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaManifiesto(item.id)">
                        <i class="far fa-file-pdf"></i>
                      </b-button>
                    </template>

                    <template v-slot:item.entidad="{ item }">
                      <div class="text-left"> {{item.Tipo_Dec}}</div>
                    </template>
                    <template v-slot:item.fiscal="{ item }">
                      <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargaFiscal(item.declaracion_fiscal)">
                        <i class="far fa-file-pdf"></i>
                      </b-button>
                    </template>
                    <template v-slot:item.entidad="{ item }">
                      <div class="text-left"> {{entidadHistorico(item.datos_encargo_actual)}}</div>
                    </template>

                  </v-data-table>
                </div>
              </div>
            </div>
            <!-- <div class="row" style="margin: 12px;">
              <div class="col-12 text-right">
                <button class="btn btn-info btn-fill btn-wd btn-next" @click="siguente()">Siguiente</button>
              </div>
            </div> -->
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import moment from 'moment'
import swal from 'sweetalert2'
export default {
    data () {
      return {
        rol: null,
        ip_id: null,
        el_archivo: '',
        wizardModel: {},
        fiscal: [],
        // entes: [],
        xlsx: 0,
        currentYear: '',
        add_item: false,
        edit_item: false,
        search: '',
        form_item: {},
        table_list: [],
        headers: [{
          text: 'Año',
          value: 'anio',
          align: 'center',
          class: '',
          width: '200px'
        }, {
          text: 'Declaración Patrimonial y de intereses',
          value: 'patrimonial',
          align: 'center',
          class: ''
        }, {
          text: 'Tipo',
          value: 'Tipo_Dec',
          align: 'center',
          class: ''
        },
        {
          text: 'Acuse',
          value: 'acuse',
          align: 'center',
          class: ''
        },
        {
          text: 'Manifiesto',
          value: 'manifiesto',
          align: 'center',
          class: ''
        },
        {
          text: 'Declaración fiscal',
          value: 'fiscal',
          align: 'center',
          class: ''
        }, {
          text: 'Entidad / Dependencia',
          value: 'entidad',
          align: 'center',
          class: ''
        }
        ]
      }
  },
    components: {
      FormWizard
    },
    computed: {
      fileExist () {
        let obj = this.table_list.find(o => moment(o.created_at, 'YYYY-MM-DD').format('YYYY') === this.currentYear)
        if (obj) {
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {
      checkAnio (item) {
        if (item.periodo) {
          return item.periodo
        } else {
          return this.filterAnio(item.created_at)
        }
      },
      descargaResumen (item) {
        var params = {
          id: item.id,
          ip_id: this.ip_id,
          declaracion_id: item.declaracion_id,
          publica: false
        }

        this.$http.post(this.$http.options.root + 'descargaDeclaracion', params, {
          responseType: 'arraybuffer'
        }).then(
        response => {
          this.downloadFile(response, 'Declaración')
        },
        error => {
          this.StepError(error)
        }
      )
      },
      descargaAcuse (id) {
        this.$http.get(this.$http.options.root + 'getAcuse/' + id, {
          responseType: 'arraybuffer'
        }).then(
          response => {
            this.downloadFile(response, 'Acuse')
          },
          error => {
            this.StepError(error)
          }
        )
      },
      descargaManifiesto (id) {
        this.$http.get(this.$http.options.root + 'getManifiesto/' + id, {
          responseType: 'arraybuffer'
        }).then(
        response => {
          this.downloadFile(response, 'Manifiesto')
        },
        error => {
          this.StepError(error)
        }
      )
      },
      descargaFiscal (file) {
        let obj = JSON.parse(file)
        if (obj[0]) {
          var url = ['https:' + this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file]
          window.open(url, '_blank')
        } else {
          this.StepW('No tiene declaración fiscal')
        }
      },

      entidadHistorico (item) {
        var obj = JSON.parse(item)[0]
        return this.filterCatalog(obj.ente_publico_id, this.dependencias)
      },


      checkPermissions () {
        // && this.getKey('grupo') != 3
        if (!(this.getKey('role') == 0 && this.getKey('status_dec') == 1)) {
          localStorage.clear()
          this.$router.push('/login')
          this.$router.go()
        }
      }

    },
    created () {
      this.currentYear = moment().format('YYYY')

    // this.checkPermissions()
      this.ip_id = this.getId()

    // this.rol = this.getKey("grupo");

      this.$http.get('bitacoraDeclaracion/' + this.ip_id).then(
        response => {
          this.table_list = response.data.response
        },
        error => {
          this.Err(error)
        }
      )

      // this.$http.get('cat_ente_publico').then(response => {
      //   this.entes = response.data.entes_publicos
      // }, error => {
      //   this.StepError(error)
      //   console.log(error)
      // })
  }
  }

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }


  .custom-file-label::after {
    content: "Buscar" !important;

  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Historico.vue